export const AGENT_PROVIDERS = ['anthropic', 'openai', 'bedrock_anthropic'];
export const DEFAULT_PROVIDER = 'anthropic';
